import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./Router/AppRouter";
import "./Styles/GlobalStyles.css";
import { API_URL, IMAGE_URL } from "./config";

// Global Fetch Interceptor
// Not: Tüm istekler artık config.js üzerinden .env'den okunan API_URL ile yapılır.
// Bu interceptor yalnızca iki güvenlik ağı görevi görür:
//  1. Görece (/api, /api-erenis) yazılmış eski çağrıları .env adresine yönlendirir.
//  2. Veritabanındaki eski (localhost) resim yollarını .env'deki IMAGE_URL'e çevirir.
const originalFetch = window.fetch;
window.fetch = async function (url, options) {
  if (typeof url === 'string') {
    if (url.startsWith('/api-erenis/')) {
      url = `${API_URL}${url.substring(11)}`;
    } else if (url.startsWith('/api/')) {
      url = `${API_URL}${url.substring(4)}`;
    }
  }

  const response = await originalFetch(url, options);

  // Eski kayıtlardaki localhost resim yollarını .env'deki IMAGE_URL'e dönüştürür
  const clone = response.clone();
  try {
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const data = await clone.json();
      const stringified = JSON.stringify(data);

      const correctedString = stringified.replace(
        /http:\/\/localhost:5000\/uploads/g,
        IMAGE_URL
      );

      return new Response(correctedString, {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
      });
    }
  } catch (err) {
    // Hata durumunda orijinal cevabı bozmadan devam eder
  }

  return response;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
